import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from '../../../features/bestFriends';
import { sendEvent } from '../../../lib/google-analytics';
import { FriendItem } from '../../../models/FriendItem';
import { ConfirmBlock } from '../ConfirmBlock';

const detailPagePath = '/players/best-friends/detail';

export const PageConfirmBlock: React.FC<{ friendItem: FriendItem }> = ({ friendItem }) => {
  const { t } = useTranslation(['best_friends', 'translation']);
  const history = useHistory();
  const dispatch = useDispatch();

  const onBlockClick = useCallback(() => {
    const { id } = friendItem;
    dispatch(actions.deleteFriend({ id }));
    sendEvent('best_friends_block', 'click', 'person');
  }, [friendItem, dispatch]);

  const onCancelClick = useCallback(() => {
    const { id } = friendItem;
    history.replace(`${detailPagePath}/${id}`);
  }, [history, friendItem]);

  return (
    <ConfirmBlock
      title={t('translation:dialog_warning')}
      description={t('dialog_delete_ask_00')}
      confirm={t('button_delete_best_friends')}
      gaEventLabel={'person'}
      onBlockClick={onBlockClick}
      onCancelClick={onCancelClick}
    />
  );
};
